// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
})();

// Only send Weglot request if the current language is different from English
function isWeglotActive() {
	if (!window.Weglot || !window.Weglot.initialized) {
			return false;
	} else {
		var currentLang = Weglot.getCurrentLang();
// Change 'en' to suitable with original language of the store
		return currentLang !== 'en';
	}
}

InstantSearchApi.beforeCallAsync = function(searchTerm, callInstantSearchApi) {
	// Then use it in our API
	if (window.Weglot && window.Weglot.initialized && isWeglotActive()) {
			Weglot.search(searchTerm, function(englishTerm) {
	Globals.instantSearchQueryParams['q'] = englishTerm;
				callInstantSearchApi();
			 });
	} else {
			callInstantSearchApi();
	}
}